import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { IoSendSharp } from "react-icons/io5";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Carousel from "react-bootstrap/Carousel";
import Footer from "./Footer";
import Header from "./Header";
import Scroll from "./Scroll";
import Card from "react-bootstrap/Card";
import image from "../Assets/profile-banner.jpg";
// import image1 from "../Assets/home_shasti.png";
// import image2 from "../Assets/safety.jpg";
import Stats from "./Stats";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import CrackersLoader from './CrackersLoader';
import Animation from "./Animation"
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Adbanner from '../Assets/middle-banner.jpg';
// import Adbanner1 from '../Assets/mft-banner-22.jpeg';
// import Adbanner2 from '../Assets/mft-banner1.jpg';
// Swiper styles
import "swiper/css";
import "swiper/css/autoplay";
import Sticker from "./Sticker";
import img from '../Assets/profile-img.jpg'
// import img1 from '../Assets/ark-banner-2.jpg'
import { Container, Row, Col } from 'react-bootstrap';
import Image  from '../Assets/darshan-1.png'



function Home() {
  const [isChatBoxVisible, setChatBoxVisible] = useState(false);
  const [showDos, setShowDos] = useState(true);
  const [categories, setCategories] = useState([]);
  const [carouselImages, setCarouselImages] = useState([]);
  const [marqueeText, setMarqueeText] = useState([]);
  const [message, setMessage] = useState("");
  const [homeData, setHomeData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [gallery, setGallery] = useState([]);
  const [clientlogo, setClientLogo] = useState([]);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const[youtubeurl, setYouTubeUrl] = useState();
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  

  const toggleChatBox = () => {
    setChatBoxVisible(!isChatBoxVisible);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const sendMessage = () => {
    if (!whatsappNumber) {
      console.log("WhatsApp number is not available yet");
      return;
    }

    const whatsappUrl = `https://wa.me/${whatsappNumber.replace(
      "+",
      ""
    )}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          "https://dharshancrackers.com/customer_api/home.php"
        );
        const { body } = response.data;
        setCategories(body?.category_front || []);
        setCarouselImages(body?.banner || []);
        setMarqueeText(body?.scrollnew?.map(item => item.msg) || []);
        setGallery(body?.gallery || []);
        setClientLogo(body?.client_logo || []);
       const extractYouTubeVideoId = (url) => {
            const regex = /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/;
            const match = url.match(regex);
            return match ? match[1] : null;
          }; 

          // Usage:
          const Youtubeurl = body?.youtube_url;
          const videoId = extractYouTubeVideoId(Youtubeurl);
          const embedUrl = videoId ? `https://www.youtube.com/embed/${videoId}` : null;
          setYouTubeUrl(embedUrl);
          console.log(embedUrl);

      } catch (error) {
        console.error("There was an error fetching the data!", error);
      } finally {
        setIsLoading(false); // Stop loading after data is fetched
      }
    };
    fetchData();
  }, []);


  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const response = await axios.get(" https://dharshancrackers.com/customer_api/content.php");
        const { body } = response.data;
        const { whatsapp_number } = response.data.body.contact;
        setHomeData(body.home);
        setWhatsappNumber(whatsapp_number);
      } catch (error) {
        console.error("Error fetching the about data", error);
      }
    };
    fetchHomeData();
  }, []);

  if (isLoading) {
    return <CrackersLoader />;
  }

  if (!homeData) {
    return <p> </p>;
  }


  const handleCategoryClick = (category) => {
    navigate('/quick', { state: { selectedCategory: category.category_name } });
  };



  return (
    <div className="main-homepage">
      <Header />

      {/* Carousel Section */}
      <div
        className="carousel-container"
        style={{ position: "relative", overflow: "hidden" }}
      >
        <Carousel interval={3000}>
          {carouselImages.map(({ id, image }) => (
            <Carousel.Item key={id}>
              <img
                className="d-block w-100 "
                src={image}
                alt="Carousel slide" />
            </Carousel.Item>
          ))}

          {/* <Carousel.Item>
     <img
       className="d-block w-100"
       src={img}
        alt="Carousel slide"
     />
   </Carousel.Item>
 
   <Carousel.Item>
     <img
       className="d-block w-100"
       src={img1}
   alt="Carousel slide"
   />
   </Carousel.Item> */}

        </Carousel>
        {/* <Animation /> */}
      </div>

      {/* Marquee Section */}
      <div className="marquee-container">
        <div className="marquee">
          <p>{marqueeText}</p>
        </div>
      </div>

      {/*   content  Section */}
      {/* <div class="banner-wrapper">
        <img src={Adbanner1} alt="Ad Banner 1" class="banner-img1" />
        <img src={Adbanner2} alt="Ad Banner 2" class="banner-img1" />
      </div> */}


      <div className="content-section counter-bg">
        {/* Top Image */}
        <div className="topimg">
          <div className="blob-shape">
            <img src={img} alt="cloud-shaped" />
          </div>
        </div>

        {/* Content aligned to the right */}
        <div className="content-text">
          {/* <br/>
          <br/> */}
          <h5 style={{ color: "black" }}><b>Welcome to</b></h5>
          <h1 style={{ letterSpacing: "1px", color: "red" }}>DHARSHAN CRACKERS</h1>
          <h1 style={{ color: "black" }}>
            WHOLESALE & RETAIL SHOP IN <span style={{ color: "red" }}>METTAMALAI</span>
          </h1>
          <br />
          <p
            style={{
              fontFamily: "Arial, Helvetica, sans-serif",
              color: "black",
              fontSize: "18px"
            }}
            dangerouslySetInnerHTML={{ __html: homeData.value }} />
          <br />
          <hr />
          <div className="adlist">
            <div className="adlist2">
              <p><i className="bi bi-check tick"></i> <span>Best Quality</span></p>
              <p><i className="bi bi-check tick"></i> <span>Best price</span></p>
            </div>
            <div className="adlist1">
              <p><i className="bi bi-check tick"></i> <span>Safe to Use</span></p>
            </div>
          </div>
        </div>

        {/* SVG Wave */}
        <div className="wave-cloud">
          <svg viewBox="0 0 1440 100" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <path
              fill="#ffffff"
              d="M0,64 C90,100 180,0 270,64 C360,128 450,0 540,64 C630,128 720,0 810,64 C900,128 990,0 1080,64 C1170,128 1260,0 1350,64 C1440,128 1440,128 1440,128 L1440,0 L0,0 Z" />
          </svg>
        </div>


      </div>

      <Sticker />
      {/*categories section */}

      <div style={{ height: "auto" }}>
        <div>
          <div className="newarr">
            <div className="horizontal-line-text-container">
              <hr className="line" />
              <h4 className="text123">Our Top Categories </h4>

              <hr className="line" />
            </div>

            <div className="newarrival">
              {categories.map((category) => (
                <div key={category.category_id}
                  className="card-container"
                  onClick={() => handleCategoryClick(category)}
                  style={{ cursor: 'pointer' }}
                >
                  {/* <Link to="/quick"> */}
                  <Card
                    // style={{ width: "14rem" }}
                    className="sub-banner custom-shadow "
                  >
                    <img
                      src={category.image}
                      alt={category.category_name}
                      className="d-block   img12" />
                    <Card.Body>
                      <Card.Title className="imgname">
                        {category.category_name}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                  {/* </Link> */}
                </div>
              ))}
            </div>

            <br />
          </div>
        </div>


      </div>

   {/* <div className="ad-banner-wrapper">
        <img src={Adbanner} alt="Advertisement Banner" className="ad-banner-img" />
      </div> */}

      <div className="wave-section">
  <div className="wave-top">
    <svg viewBox="0 0 1440 100" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
      <path 
        fill="#ffffff"
                 d="M0,64 C90,100 180,0 270,64 C360,128 450,0 540,64 C630,128 720,0 810,64 C900,128 990,0 1080,64 C1170,128 1260,0 1350,64 C1440,128 1440,128 1440,128 L1440,0 L0,0 Z" />

    </svg>
  </div>
      <div className="wave-content">
        <div className="text-content">
          <h5>Get Your Estimate</h5>
          <h2><nobr>Sivakasi Online Crackers</nobr><br />Low Budget</h2>
          <Link to='/quick' className="estimate-btn">Estimate →</Link>
        </div>

        {/* <div className="image-content">
          <img src={Image} alt="Boy with Firecracker" />
        </div> */}
        <div className="topimg">
          <div className="topimg">
            <img src={Image} alt="cloud-shaped" />
          </div>
        </div>
      </div>
      </div>
      <br />

      <div className="horizontal-line-text-container">
        <hr className="line" />
        <h4 className="text123">Gallery </h4>

        <hr className="line" />
      </div>

      <div className="gallery-slider-container">

        <Swiper
          slidesPerView={4}
          spaceBetween={10}
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 10 },
            480: { slidesPerView: 2, spaceBetween: 10 },
            768: { slidesPerView: 3, spaceBetween: 10 },
            1024: { slidesPerView: 4, spaceBetween: 10 },
          }}
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          modules={[Autoplay]}
          className="gallery-swiper"
        >
          {gallery.map((logo, index) => (
            <SwiperSlide key={index} className="gallery-slide">
              <div className="gallery-card">
                <img src={logo.image} alt={`Client ${index}`} className="gallery-image" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>

<div className="wave-cloud1">
        <svg viewBox="0 0 1440 100" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path
            fill="#dbe7e9ff"
            d="M0,64 C90,100 180,0 270,64 C360,128 450,0 540,64 C630,128 720,0 810,64 C900,128 990,0 1080,64 C1170,128 1260,0 1350,64 C1440,128 1440,128 1440,128 L1440,0 L0,0 Z" />
        </svg>
      </div>

      <div className="how-to-order  ">

        <div className="how-to-order-header text-center mb-4">

          <h4 className=" text123">How to Order?</h4>
          <p className="how-to-order-subtext">
            Due to the 2018 Supreme Court regulations, direct online sales of firecrackers are restricted.
            However, we have made the ordering process easy for our customers.
          </p>
        </div>

        <div className="row">
          {/* Step 1 */}
          <div className="col-xl-3 col-lg-4 col-md-6">
            <div className="order-step text-center ">
              <div className="order-icon-svg text-center">
                <svg
                  width="180"
                  height="130"
                  viewBox="0 0 640 522"
                  xmlns="http://www.w3.org/2000/svg"
                  className="svg-cloud-bg"
                >
                  <path
                    fill="#FFA13B"
                    d="M537.6 226.6C534.7 151.7 472 96 396 96c-26.2 0-50.5 8.4-70.2 22.5C306.4 84.3 267.5 64 224 64c-66.3 0-120 53.7-120 120 0 3 .1 6 .3 9C46.2 205.6 0 252.1 0 310.4 0 370.4 49.6 416 110.4 416H496c61.9 0 112-50.1 112-112 0-54.4-39.4-99.7-90.4-106.4z" />
                </svg>
                <i className=" fas fa-shopping-cart svg-icon-center"></i> {/* Updated Icon */}
              </div>
              <div className="order-text">
                <h4>Step 1</h4>
                <p>
                  Click the 'Quick Purchase'  menu or 'Pre Order Now' button  and add your crackers you wants.
                </p>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="col-xl-3 col-lg-4 col-md-6">
            <div className="order-step text-center">
              <div className="order-icon-svg text-center  ">
                <svg
                  width="180"
                  height="130"
                  viewBox="0 0 640 522"
                  xmlns="http://www.w3.org/2000/svg"
                  className="svg-cloud-bg"
                >
                  <path
                    fill="#FFA13B"
                    d="M537.6 226.6C534.7 151.7 472 96 396 96c-26.2 0-50.5 8.4-70.2 22.5C306.4 84.3 267.5 64 224 64c-66.3 0-120 53.7-120 120 0 3 .1 6 .3 9C46.2 205.6 0 252.1 0 310.4 0 370.4 49.6 416 110.4 416H496c61.9 0 112-50.1 112-112 0-54.4-39.4-99.7-90.4-106.4z" />
                </svg>
                <i className=" fas fa-file-invoice svg-icon-center"></i> {/* Updated Icon */}
              </div>
              <div className="order-text">
                <h4>Step 2</h4>
                <p>Submit your order through the ‘Submit Enquiry’ option.</p>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="col-xl-3 col-lg-4 col-md-6">
            <div className="order-step text-center">
              <div className="order-icon-svg text-center">
                <svg
                  width="180"
                  height="130"
                  viewBox="0 0 640 522"
                  xmlns="http://www.w3.org/2000/svg"
                  className="svg-cloud-bg"
                >
                  <path
                    fill="#FFA13B"
                    d="M537.6 226.6C534.7 151.7 472 96 396 96c-26.2 0-50.5 8.4-70.2 22.5C306.4 84.3 267.5 64 224 64c-66.3 0-120 53.7-120 120 0 3 .1 6 .3 9C46.2 205.6 0 252.1 0 310.4 0 370.4 49.6 416 110.4 416H496c61.9 0 112-50.1 112-112 0-54.4-39.4-99.7-90.4-106.4z" />
                </svg>
                <i className=" fas fa-user-check svg-icon-center"></i> {/* Updated Icon */}
              </div>
              <div className="order-text">
                <h4>Step 3</h4>
                <p>Our team will contact you within two hours to confirm your order.</p>
              </div>
            </div>
          </div>


          {/* Step 4 */}
          <div className="col-xl-3 col-lg-4 col-md-6">
            <div className="order-step text-center">
              <div className="order-icon-svg text-center">
                <svg
                  width="180"
                  height="130"
                  viewBox="0 0 640 522"
                  xmlns="http://www.w3.org/2000/svg"
                  className="svg-cloud-bg"
                >
                  <path
                    fill="#FFA13B"
                    d="M537.6 226.6C534.7 151.7 472 96 396 96c-26.2 0-50.5 8.4-70.2 22.5C306.4 84.3 267.5 64 224 64c-66.3 0-120 53.7-120 120 0 3 .1 6 .3 9C46.2 205.6 0 252.1 0 310.4 0 370.4 49.6 416 110.4 416H496c61.9 0 112-50.1 112-112 0-54.4-39.4-99.7-90.4-106.4z" />
                </svg>
                <i className="fas fa-box-open svg-icon-center"></i>
              </div>
              <div className="order-text">
                <h4>Step 4</h4>
                <p>We’ll pack your firecrackers and deliver them on time to your area.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div className="wave-cloud-bottom">
        <svg viewBox="0 0 1440 100" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path
            fill="#dbe7e9ff"
            d="M0,64 C90,100 180,0 270,64 C360,128 450,0 540,64 C630,128 720,0 810,64 C900,128 990,0 1080,64 C1170,128 1260,0 1350,64 C1440,128 1440,128 1440,128 L1440,0 L0,0 Z" />
        </svg>
      </div>
      

      <div className="horizontal-line-text-container">


        <hr className="line" />
        <h4 className="text123">Brands </h4>

        <hr className="line" />
      </div>

      <div className="client-logo-section">
        <Swiper
          slidesPerView={6}
          spaceBetween={20}
          breakpoints={{
            320: { slidesPerView: 2 },
            480: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: 6 },
          }}
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          modules={[Autoplay]}
        >
          {clientlogo.map((logo, index) => (
            <SwiperSlide key={index} className="client-logo-slide">
              <img src={logo.image} alt={`Client ${index}`} className="client-logo-img" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

<section className="full-width-video">
        <div className="video-wrap">
          {/* Background Image */}
          <div className="video-bg">
            <img src={img} alt="Background" />
          </div>

          {/* Optional video tag (can be removed if not used) */}
          <video id="bg-video" preload="auto" muted>
            <source src="" type="video/mp4" />
            Your browser doesn't support HTML5 video.
            <a href="">Download Video</a>
          </video>

          {/* Play Button Overlay */}
          <div className="video-text text-center video-controls">
            <button
              className="play-btn"
              onClick={handleOpenModal}
              style={{ background: 'none', border: 'none' }}
            >
              <i
                className="fa fa-play-circle"
                style={{ fontSize: '80px', color: '#fff' }}
              ></i>
            </button>
            <h2 className="text-lt text-sp">SEE HOW WE PREPARE YOUR MEAL</h2>
          </div>
        </div>
      </section>
      
{showModal && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.8)' }}
          tabIndex="-1"
          role="dialog"
          onClick={(e) => {
              // ✅ Close modal if clicked outside the modal-dialog
              if (e.target.classList.contains('modal')) {
              handleCloseModal();
              }
          }}
        >
        
          <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-body p-0 position-relative">
               <button
                  type="button"
                  className="btn-close position-absolute top-0 end-0 m-2"
                  aria-label="Close"
                  onClick={handleCloseModal}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    fontSize: '2rem',
                    color: '#fff',
                    zIndex: 10,
                  }}
                >
                  &times;
                </button>
                <div className="ratio ratio-16x9">
                <iframe
                  width="100%"
                  height="100%"
                  src={youtubeurl}
                  title="YouTube video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

              </div>
            </div>
          </div>
        </div>
      )}
      {/* <div className="content-section1">
              
              <div className="content-text">
                
                <br />
                <h3 style={{ letterSpacing: "2px", color: "#c43004" }}>
                  SAFETY TIPS
                </h3>
                <div className="dos">
                  <Button
                    as="input"
                    type="button"
                    value="DO'S"
                    className="doss"
                    onClick={() => setShowDos(true)}
                  />
                  <Button
                    as="input"
                    type="button"
                    value="DON'TS"
                    className="donts"
                    onClick={() => setShowDos(false)}
                  />
                </div>
                <br />
                {showDos ? (
                  <div className="dos-content">
                    <p >
                      Here are some important safety tips you should follow when using
                      our products:
                    </p>
                    <ul>
                      <li>
                        If you have to buy fireworks, be sure to buy them from a
                        licensed dealer
                      </li>
                      <li>Keep a bucket of sand or a fire extinguisher handy.</li>
                      <li>
                        Ensure there are no inflammable and combustible materials
                        around the fire-cracking area
                      </li>
                      <li>Follow all safety precautions issued with the fireworks</li>
                      <li>Discard used fireworks in a bucket of water</li>
                      <li>Burst crackers in safe places that are not crowded</li>
                      
                    </ul>
                  </div>
                ) : (
                  <div className="donts-content">
                    <p>
                      Avoid these actions to ensure safety:
                    </p>
                    <ul>
                      <li>Don't let children play alone with firecrackers</li>
                      <li>
                        Don't keep the firecrackers near burning diyas or agarbattis.
                      </li>
                      <li>
                        Don't wear synthetic or loose garments; thick cotton clothes
                        are ideal.
                      </li>
                      <li>
                        Don't light crackers while holding them in your hand; you
                        should always light them in open grounds pointing straight up
                      </li>
                     
                    </ul>
                  </div>
                )}
               
              </div>
              <div className="topimg">
                <img src={image2} alt="Top" />
              </div>
            </div> */}
      {/* <Stats /> */}

      <div className="minifooter1">
        <div className="minimenu">

          <Link to="/">
            <div style={{ display: "flex", flexDirection: "column", color: "white" }}>
              <i class="bi bi-house-door" style={{ marginLeft: "12px", fontSize: "1.4rem" }}></i>
              Home
            </div>
          </Link>

          <Link to="/about">
            <div style={{ display: "flex", flexDirection: "column", color: "white" }}>
              <i class="bi bi-journal-text officon" style={{ marginLeft: "20px", fontSize: "1.4rem", color: "white" }}></i>
              About Us
            </div>
          </Link>


          <Link to="/quick">
            <div style={{ display: "flex", flexDirection: "column", color: "white" }}>
              <i class="bi bi-bag" style={{ marginLeft: "18px", fontSize: "1.4rem" }}></i>
              Enquiry
            </div>
          </Link>



          <Link to="/contact">
            <div style={{ display: "flex", flexDirection: "column", color: "white" }}>
              <i class="bi bi-telephone" style={{ marginLeft: "12px", fontSize: "1.4rem" }}></i>
              Contact
            </div>
          </Link>

        </div>
      </div>

      {/* Floating WhatsApp Icon */}
      {/* WhatsApp Icon */}
      <div className="floating-whatsapp-container">
        <div className="floating-whatsapp" onClick={toggleChatBox}>
          <FontAwesomeIcon icon={faWhatsapp} />
        </div>
        {isChatBoxVisible && (
          <div className="chat-box">
            <div className="wats-header">
              <p>Dharsan Crackers</p>
              <button className="close-button" onClick={toggleChatBox}>
                X
              </button>
            </div>
            <div className="wats-content">
              <p>Welcome To Dharsan Crackers</p>
            </div>
            <div className="chat-content">
              <textarea
                placeholder="Type your message here..."
                value={message}
                onChange={handleMessageChange}
              ></textarea>
              <button onClick={sendMessage}>
                <IoSendSharp />
              </button>
            </div>
          </div>
        )}
      </div>
      <Scroll />
      <Footer />
    </div>

  );
}

export default Home;
